// Which protocol a transport (from /api/health's `transports` list) speaks.
// The contract doesn't have a dedicated `protocol` field on TransportStatus
// either, so this matches on `kind`/`id` substrings — the same defensive,
// documented-heuristic approach as lib/nodeProtocol.ts, used to decide which
// protocols the protocol toggle should even offer: do not show a
// toggle for a protocol with no transport — base that on /api/health's
// transport list, not on whether packets have happened to arrive yet.
import type { TransportStatus } from "../api/types";
import type { Protocol } from './definitions/protocols';

// Same substring heuristic, exposed for a bare transport id string — used
// by Alerts > Broadcast to sort a hazard event's `would_send_to[].transport`
// (real values seen live: "meshtastic_vnode", plus whatever a future
// MeshCore route cell resolves to) into a protocol section without a
// second ad-hoc matcher.
export function transportIdProtocol(id: string): Protocol | null {
  const s = id.toLowerCase();
  if (s.includes("meshcore")) return "meshcore";
  if (s.includes("meshtastic")) return "meshtastic";
  return null;
}

export function transportProtocol(t: TransportStatus): Protocol | null {
  return transportIdProtocol(`${t.kind} ${t.id}`);
}

export function availableProtocols(transports: TransportStatus[] | undefined): Protocol[] {
  if (!transports) return [];
  const set = new Set<Protocol>();
  for (const t of transports) {
    const p = transportProtocol(t);
    if (p) set.add(p);
  }
  return [...set];
}
